<template>
  <div class="c-smartptom">
    <!-- filter -->
    <smartPtom-filter placeholder="请输入项目名称或ID" @on-change="filterData" @on-search="searchFilterData" />
    <div class="c-control-btn">
      <div class="c-btn">
        <ElButton type="primary" @click="toSmartPtom">智能自动化</ElButton>
      </div>
      <div>
        <ElButton icon="md-download" @click="down">数据导出</ElButton>
        <ElButton @click="modalColumn = true">自定义列</ElButton>
      </div>
    </div>

    <!-- table -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <smartPtom-table
          ref="smartPtomTable"
          :loading="loading"
          :height="tableHeight"
          :data="tableList"
          :columns="tableCols"
          :datetime="datetime"
          @on-refresh="getData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="columns" :subTitle="['基础数据', '报表数据', '留存数据']" @on-select="selectColumn" />
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import mixin from './mixin'
import mixins from '../mixins/mixin'
import columns from '../data/smartptom_column'
import { setLocal } from '@/common/js/api'
import { isArray, setLocalInfo } from '@/common/js/utils'
import SmartPtomFilter from './components/smartptom-filter'
import SmartPtomTable from './components/smartptom-table'
import { listMonitorProject } from '@/api/manage.model'
import CustomColumn from '@/components/converter/custom-column.vue'
import { HOST_API } from '@/api/config'

export default {
  name: 'smartptom',
  mixins: [mixins, mixin],
  components: { SmartPtomFilter, SmartPtomTable, CustomColumn },
  computed: {
    custom() {
      return 'smartptom1'
    },
    tableCols() {
      return this.columns.filter((ret) => !ret.show)
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.smartPtomTable && this.$refs.smartPtomTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.datetime = [params.beginTime, params.endTime]
      this.loading = true
      listMonitorProject(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    toSmartPtom() {
      const account = Cookies.get('ch_user_name')
      const id = Cookies.get('ch_op_id')
      setLocalInfo(id, account, '10')
      window.open('/create/robot/project', '_blank')
    },
    down() {
      let url = `${HOST_API}/api/ptom/intelligent/project/down`
      url += `?sessionid=${this.$store.state.token}`
      url += `&beginTime=${this.params.beginTime}`
      url += `&endTime=${this.params.endTime}`
      this.params.keyword && (url += `&keyword=${this.params.keyword}`)
      this.params.adAccountId > 0 && (url += `&adAccountId=${this.params.adAccountId}`)
      this.params.opId > 0 && (url += `&opId=${this.params.opId}`)
      this.params.gameId > 0 && (url += `&gameId=${this.params.gameId}`)
      window.open(url)
    },
    setLocalPage(size) {
      setLocal('SMARTPTOMDATA_PAGESIZE', size)
    }
  },
  data() {
    return {
      tableHeight: 330,
      tableList: [],
      modalColumn: false, // 自定义列
      columns: columns,
      datetime: []
    }
  },
  created() {
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 同步本地存储自定义列
    if (shows.length) {
      const local_shows = shows
        .filter((ret) => ret && columns.some((met) => met.key === ret))
        .map((ret) => {
          const item = columns.filter((met) => met.key === ret).pop() || {}
          item.show = false
          return item
        })
      const extend_shows = columns
        .filter((ret) => !shows.includes(ret.key))
        .map((ret) => {
          ret.show = true
          return ret
        })
      this.columns = [...local_shows, ...extend_shows]
    } else {
      this.columns = [...columns]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-control-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
